// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import siteMessage from "@insite/client-framework/SiteMessage";
import GridItem from "@insite/mobius/GridItem";
import Notify from "@steiner/App/Components/Notify";
import { SectionContainer, SectionTitle } from "@steiner/App/Widgets/DesignSystem/DesignSystem.helpers";
import React, { FC } from "react";

const NotifyTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem width={12}>
                <SectionTitle>Notify</SectionTitle>
            </GridItem>
            <GridItem width={12}>
                <Notify type="success" title="Success">
                    Here is an explanation It drops to next line if content is too long.
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="danger" title="Danger">
                    Danger
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="info" title="Info">
                    Info
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="warning" title="Warning">
                    Warning
                </Notify>
            </GridItem>
        </SectionContainer>
    );
};

export default NotifyTab;
